module Meevo.Plugins.Client {
    "use strict";

    import CommunicationTypeEnum = Meevo.Model.CommunicationTypeEnum;

    /**
    * Main Section of Client
    */
    export class NotificationsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        private securityKeys = Meevo.Components.Common.SecurityKeys;
        private securityParts = Meevo.Components.Common.SecurityParts;
        public missingField: any = -1;
        public securityKeyCreate = this.securityKeys.DATA_CLIENT_TAB_NOTIFICATIONS + this.securityParts.KEY_PART_CREATE;
        public excludeSelf: Array<any> = [];
        public guardianTypeAheadCriteria: any = { 'ExcludeMinorClients': true, isGlobal: true };
        public customButtonsSet: Array<Meevo.Components.Controls.IMaintenanceFormCustomButton>;
        guardianTemp: any;
        guardian: any;
        formerGuardian: any;
        _sectionSeurityKey: string;
        clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings;
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            identityService: Meevo.Components.Common.IIdentityService,
            public securityService: Meevo.Components.Common.ISecurityService,
            noun: Meevo.Model.NounEnum,
            appSettings: Components.Common.IAppSettings,


            protected modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            private context: Meevo.Components.BaseClasses.IDataMaintenanceContext,

            public $rootScope: angular.IRootScopeService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);

            this._sectionSeurityKey = sectionSecurityKey;

        }

        /**
        * Base class override which defines the rules to use when copying the model.
        */
        createSectionModelCopy(): Model.Client {
            let item = <Model.Client>(this.model);
            item.referredByEnum = Meevo.Model.ReferredByEnum.Client;
            var detail = {
                id: this.model.id,
                displayName: this.model.lastName + ", " + this.model.firstName,
                referredBy: item.referredByEnum
            }
            item.referredByDetail = detail;
            // Reset values
            item.id = null;
            item.prefix = null;
            item.firstName = null;
            item.middleName = null;
            item.objectState = Meevo.Model.ObjectStateEnum.Active;
            item.isRestricted = false;
            item.onlineBookingAccess = true;
            item.isMinor = false;
            item.gender = Meevo.Model.GenderEnum.NotSpecified;
            item.emailAddress = null;
            item.isEmailOptedIn = false;
            item.birthDay = null;
            item.birthMonth = null;
            item.anniversaryDate = null;
            // Copy all numbers except for mobile and set home to primary
            _.forEach(item.phoneNumbers, number => {
                if (number.id) {
                    switch (number.type) {
                        case Meevo.Model.PhoneTypeEnum.Mobile:
                            number.isPrimary = false;
                            number.number = null;
                            number.phoneNumber = null;
                            number.useForSMS = false;
                            number.extension = null;
                            number["smsOptInStateEnum"] = null;
                            number["smsOptInStateDateUpdated"] = null;
                            break;
                        case Meevo.Model.PhoneTypeEnum.Work:
                            number.isPrimary = false;
                            number.number = null;
                            number.phoneNumber = null;
                            number.useForSMS = false;
                            number.extension = null;
                            number["smsOptInStateEnum"] = null;
                            number["smsOptInStateDateUpdated"] = null;
                            break;
                        case Meevo.Model.PhoneTypeEnum.Home:
                            number.isPrimary = true;
                            break;
                    }
                }
            });
            // Reset appointment confirmation notification setting
            var notification = _.find(item.notificationOptions, (notif: any) => {
                return notif.communicationType === CommunicationTypeEnum.AppointmentConfirmation;
            });
            if (notification) {
                notification.sendDaysBefore = notification.sendDaysBeforeDefault;
                notification.isCallEnabled = true;
            }

            //this.initializeReferredByExclusionList();
            return item;
        }

        /**
        * Handles setting the primary phone number for the client.
        * Insures that only 1 phone number is set as primary.
        * @param {Model.Phone} Selected phone number
        * @param {Model.Phone[]} Collection of client phone numbers
        * @return {}
        */
        //noConfirmations: boolean = false;
        tempNotification: Array<any> = [];

        notificationAvabilityChanged() {
            let that = this;
            if (this.model.doNotConfirm) {

                this.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {
                    let temp = {
                        call: notificationSetting.isCallEnabled,
                        email: notificationSetting.isEmailEnabled,
                        sms: notificationSetting.isSMSEnabled,
                    }

                    that.tempNotification[index] = temp

                    notificationSetting.isCallEnabled = false;
                    notificationSetting.isEmailEnabled = false;
                    notificationSetting.isSMSEnabled = false;
                });
            }
            else {
                if (this.tempNotification.length > 0) {
                    let that = this;
                    this.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {
                        notificationSetting.isCallEnabled = that.tempNotification[index].call;
                        notificationSetting.isEmailEnabled = that.tempNotification[index].email;
                        notificationSetting.isSMSEnabled = that.tempNotification[index].sms;
                    })
                }
                else {
                    let businessNotificationSettings;
                    let borp = this.appSettings.API_ENDPOINTS.notificationSetting
                    let that = this;
                    this.dataService.customMethodData("api/notificationSetting/?BusinessType_TId=" + this.identityService.businessTypeId, "GET", undefined).then(function (result) {
                        let appointmentConfirmations = _.find(result.data.communicationTypeNotifications, function (item: any) {
                            if (item.communicationTypeDisplay == "Appointment Confirmations") {
                                return true;
                            }
                            return false;
                        });
                        that.scheduledNotificationOptions.forEach(function (notificationSetting, index, array) {

                            notificationSetting.isCallEnabled = appointmentConfirmations.isCallEnabled;
                            notificationSetting.isEmailEnabled = appointmentConfirmations.isEmailEnabled;
                            notificationSetting.isSMSEnabled = appointmentConfirmations.isSMSEnabled;
                        });
                    });

                }
            }
        }

        get scheduledNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions.filter(i => i.communicationType === 1795 || i.communicationType === 1833 || i.communicationType === 11045056);
        }

        get immediateNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions.filter(i => i.communicationType === 1817 || i.communicationType === 1832 || i.communicationType === 2036 || i.communicationType === 2103);
        }

        get communicationTypeEnum(): any {
            return CommunicationTypeEnum;
        }

        get miscNotificationOptions() {
            if (!this.model || !this.model.notificationOptions) return [];

            return this.model.notificationOptions
                .filter(i => i.communicationType === CommunicationTypeEnum.FiveStarSurvey || i.communicationType === CommunicationTypeEnum.ProductPurchaseReminder);
        }



        initializeGuardian() {
            if (this.model) {
                this.excludeSelf = [this.model];
                if (this.model.guardianId) {

                    this.dataService.getItem(this.baseEndpoint, this.model.guardianId).then((data) => {
                        this.guardian = data;
                        let temp: any = (_.findWhere(this.guardian.phoneNumbers, { isPrimary: true }));
                        this.guardian.primaryPhoneNumberCountryCode = temp.countryCode;
                        this.guardian.primaryPhoneNumber = temp.number;
                        if (!this.model.isMinor) {
                            this.guardianTemp = this.guardian;
                        }
                    })
                }
            }
        }

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.guardian = {};
            this.guardianTemp = {};

        }

        takeBackup() {
            super.takeBackup();
            this.formerGuardian = this.guardian;
        }

        rollbackChanges() {
            super.rollbackChanges();
            if (this.formerGuardian) {
                this.guardian = this.formerGuardian
                this.guardianTemp = this.formerGuardian
                this.model.guardianId = this.formerGuardian.id;
            }
        }

        guardianChangedNotifications() {
            if (this.guardianTemp) {
                if (!this.guardianTemp.guardianId) {
                    if (this.guardianTemp.id) {
                        this.guardian = this.guardianTemp
                        this.model.guardianId = this.guardianTemp.id;
                    }
                }
                else {
                    let message = this.$translate.instant("MESSAGE_CLIENT_NOT_OWN", {
                        ClientDisplayName: this.guardianTemp.displayName
                    });
                    this.modalService.alert(message);
                    this.model.guardianId = null;
                    this.guardian = {};
                    this.guardianTemp = {};
                }
            }
            else {
                this.model.guardianId = null;
                this.guardian = {};
                this.guardianTemp = {};
            }
        }

        revertToDefault(notification: Model.CommunicationTypeNotification): void {

            if (!notification.isSendDaysBeforeDefaultOverridden) {
                notification.sendDaysBefore = notification.sendDaysBeforeDefault;
            }

            if (!notification.isEmailEnabledDefaultOverridden) {
                notification.isEmailEnabled = notification.isEmailEnabledDefault;
            }

            if (!notification.isSmsEnabledDefaultOverridden) {
                notification.isSMSEnabled = notification.isSMSEnabledDefault;
            }
        }


        updateOverridden(notification: Model.CommunicationTypeNotification, propName: string) {
            if (!this.context.isReadonly) {
                notification[propName] = true;
            }
        }



        clearGuardianTempUnsuccessfulSave(): void {
            this.model.guardianId = null;
            this.guardian = {};
            this.guardianTemp = {};
        }




        doNotConfirmChanged: boolean = false;
        preSave() {
            this.doNotConfirmChanged = this.originalEntity && this.originalEntity.doNotConfirm !== this.model.doNotConfirm;
            super.preSave();
        }
    }
}
